import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { COMMAND_ROUTES } from '../config/platformNav';
import { WIKI_COMMAND_ROUTES } from '../content/wiki';

const ALL_COMMANDS = [...COMMAND_ROUTES, ...WIKI_COMMAND_ROUTES];

function CommandPalette({ open, onClose }) {
  const navigate = useNavigate();
  const [query, setQuery] = useState('');

  useEffect(() => {
    if (!open) {
      setQuery('');
    }
  }, [open]);

  useEffect(() => {
    const onKeyDown = (event) => {
      if (event.key === 'Escape' && open) {
        onClose();
      }
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [open, onClose]);

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) {
      return ALL_COMMANDS;
    }
    return ALL_COMMANDS.filter(
      (item) =>
        item.label.toLowerCase().includes(q) ||
        item.section.toLowerCase().includes(q) ||
        item.to.toLowerCase().includes(q)
    );
  }, [query]);

  if (!open) {
    return null;
  }

  const runCommand = (item) => {
    navigate(item.to);
    onClose();
  };

  return (
    <div className="command-palette-backdrop" onClick={onClose} role="presentation">
      <div
        className="command-palette"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label="Command palette"
      >
        <div className="command-palette-input-wrap">
          <span className="command-palette-kbd">⌘K</span>
          <input
            autoFocus
            className="command-palette-input"
            placeholder="Search commands and go to..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && filtered[0]) {
                runCommand(filtered[0]);
              }
            }}
          />
        </div>
        <div className="command-palette-results">
          {filtered.length === 0 ? (
            <div className="command-palette-empty">No matches</div>
          ) : (
            filtered.map((item) => (
              <button
                key={item.id}
                type="button"
                className="command-palette-item"
                onClick={() => runCommand(item)}
              >
                <span className="command-palette-item-label">{item.label}</span>
                <span className="command-palette-item-meta">{item.section}</span>
              </button>
            ))
          )}
        </div>
      </div>
    </div>
  );
}

export default CommandPalette;
